import { resizeBackgroundImages } from "./responsive-images";

if ($(".template-product").length) {
  const vendor = $(".section-recommended").data("vendor");
  const url = `/collections/vendors?q=${encodeURIComponent(
    vendor
  )}&view=original`;

  $.ajax({
    method: "GET",
    url: url
  }).done(function(response) {
    const $products = $(response).find(".section-collection .products > .col");
    const productSize = $products.length;
    let counter = 0;
    let shownProducts = [];

    while (true) {
      if (counter > 3) {
        break;
      }

      const productCol = $products[Math.floor(Math.random() * productSize)];
      const $productCol = $(productCol);
      const $product = $(productCol).find(".product");
      const mainProductId = parseInt($(".product--single").data("id"));
      const currentProductId = parseInt($product.data("id"));

      if (
        currentProductId !== mainProductId &&
        shownProducts.indexOf(currentProductId) === -1
      ) {
        $productCol.appendTo(".section-recommended .products");
        $productCol.find(".list-radios input:checked").prop("checked", false);
        $productCol.find(".form__btn").addClass("disabled");
        shownProducts.push(currentProductId);
        counter++;
      }
    }

    Shopify.colorLabels();
    const targetImages = document.querySelectorAll(
      "products .responsive-background-image"
    );
    resizeBackgroundImages(targetImages, "load");
  });
}
